export default [
	// {
	// 	text: 'Ingresar',
	// 	path: '/ingresar-articulo',
	// 	name: 'ingresar',
	// 	component: '@/views/Ingresar',
	// 	can: 'article.store',
	// },
	{
		text: 'Reportes',
		path: '/reportes',
		component: '@/views/Reportes',
		image_url: 'nav-icons-2/reportes.png',
		icon: 'bar-chart-line',
		// image_url: 'nav-icons/caja.png',
		name: 'reportes',
		can: 'reportes.index',
		params: {
			view: 'generales',
		},
	},
	{
		text: 'Listado',
		path: '/listado-de-articulos',
		model_name: 'article',
		component: '@/views/Listado',
		can: 'article.index',
		image_url: 'nav-icons-2/listado.png',
		icon: 'list-ul',
		// image_url: 'nav-icons/listado.png',
	},
	{
		text: 'Vender',
		path: '/vender',
		name: 'vender',
		component: '@/views/Vender',
		can: 'sale.store',
		params: {
			view: 'remito',
		},
		if_has_extencion: 'comerciocity_interno',
		image_url: 'nav-icons-2/vender.png',
		icon: 'cart-check',
		childrens: [
			{
				path: '/presupuestos',
				model_name: 'budget',
				component: '@/views/Budget',
				can: 'budget.index',
				if_has_extencion: ['budgets', 'comerciocity_interno'],
				image_url: 'nuevos-nav-icons/presupuesto.png',
				icon: 'file-earmark-text',
				// image_url: 'nav-icons/presupuestos.png',
			},
		]
	},
	{
		text: 'Alertas',
		path: '/alertas',
		component: '@/views/Alertas',
		icon: 'bell',
		budget_function: 'alerts_count',
		name: 'alertas',
		params: {
			view: 'cobros',
		},
		childrens: [
			{
				text: 'Agenda',
				path: '/agenda',
				model_name: 'pending',
				component: '@/views/Pending',
				image_url: 'nuevos-nav-icons/agenda.png',
				icon: 'calendar-check',
				can: 'pending.index',
				params: {
					view: 'por-realizar',
				},
			},
		],
	},
	{
		path: '/deposito-para-checkear',
		text: 'Deposito',
		name: 'deposito-para-checkear',
		component: '@/views/DepositoParaCheckear',
		can: 'deposito_para_checkear',
		image_url: 'nav-icons/ventas-to-check.png',
		icon: 'clipboard-check',
		if_has_extencion: 'check_sales',
		params: {
			view: 'para-checkear',
		},
	},
	{
		path: '/deposito-checkeadas',
		text: 'Checkeadas',
		name: 'deposito-checkeadas',
		component: '@/views/DepositoCheckeadas',
		can: 'deposito_checkeadas',
		image_url: 'nav-icons/ventas-checked.png',
		icon: 'patch-check',
		if_has_extencion: 'check_sales',
	},
	{
		path: '/ventas',
		model_name: 'sale',
		component: '@/views/Ventas',
		can: 'sale.index',
		function: 'toSales',
		params: {
			view: 'todas',
			sub_view: 'todos',
		},
		image_url: 'nav-icons-2/ventas.png',
		icon: 'cash-stack',
		childrens: [
			{
				path: '/por-entregar',
				text: 'Por Entregar',
				name: 'por-entregar',
				component: '@/views/PorEntregar',
				// can: 'deposito_checkeadas',
				image_url: 'nuevos-nav-icons/por_entregar.png',
				icon: 'truck',
				if_has_extencion: 'ventas_con_fecha_de_entrega',
				can: 'road_map.index',
				params: {
					view: 'ventas',
				},
			},
			{
				path: '/por-estado',
				text: 'Por Estados',
				name: 'por-estado',
				component: '@/views/PorEstado',
				image_url: 'nuevos-nav-icons/por_entregar.png',
				icon: 'ui-checks-grid',
				if_has_extencion: 'ventas_con_estados',
				params: {
					view: 'ventas',
				},
			},
			{
				text: 'Devoluciones',
				path: '/devoluciones',
				name: 'devoluciones',
				component: '@/views/Devoluciones',
				can: 'devolucion.store', 
				image_url: 'nuevos-nav-icons/devoluciones.png',
				icon: 'arrow-counterclockwise',
			},
		]
	},
	{
		text: 'Ventas',
		path: '/ventas-completas',
		name: 'VentasAll',
		model_name: 'sale',
		component: '@/views/Ventas',
		can: 'sale.index',
		image_url: 'nav-icons-2/ventas.png',
		icon: 'receipt',
		params: {
			view: 'todas',
			sub_view: 'todos',
		},
		not_show: true,
		childrens: [
			{
				text: 'Devoluciones',
				path: '/devoluciones',
				name: 'devoluciones',
				component: '@/views/Devoluciones',
				can: 'devolucion.store', 
				image_url: 'nuevos-nav-icons/devoluciones.png',
				icon: 'arrow-counterclockwise',
				// image_url: 'iconos-reportes/devoluciones.png',
			},
			{
				path: '/por-entregar',
				text: 'Por Entregar',
				name: 'por-entregar',
				component: '@/views/PorEntregar',
				// can: 'deposito_checkeadas',
				image_url: 'nuevos-nav-icons/por_entregar.png',
				icon: 'truck',
				if_has_extencion: 'ventas_con_fecha_de_entrega',
				can: 'road_map.index',
				params: {
					view: 'ventas',
				},
			}
		]
	},
	{
		path: '/rutas',
		text: 'Rutas',
		name: 'rutas',
		component: '@/views/Rutas',
		// can: 'deposito_checkeadas',
		image_url: 'nuevos-nav-icons/rutas.png',
		icon: 'signpost-split',
		if_has_extencion: 'ventas_con_fecha_de_entrega',
		can: 'road_map.terminadas.index',
	},
	// {
	// 	text: 'Devoluciones',
	// 	path: '/devoluciones',
	// 	name: 'devoluciones',
	// 	component: '@/views/Devoluciones',
	// 	can: 'devolucion.store', 
	// 	image_url: 'nuevos-nav-icons/devoluciones.png',
	// 	// image_url: 'iconos-reportes/devoluciones.png',
	// },
	{
		path: '/proveedores',
		model_name: 'provider',
		component: '@/views/Provider',
		can: 'provider.index',
		params: {
			view: 'proveedores',
		},
		if_has_extencion: 'comerciocity_interno',
		image_url: 'nav-icons-2/proveedores.png',
		icon: 'person-badge',
		// image_url: 'nav-icons/proveedores.png',
	},
	{
		path: '/clientes',
		model_name: 'client',
		component: '@/views/Client',
		can: 'client.index',
		params: {
			view: 'clientes',
		},
		if_has_extencion: 'comerciocity_interno',
		image_url: 'nav-icons-2/clientes.png',
		icon: 'people',
		// image_url: 'nav-icons/clientes.png',
	},
	// {
	// 	text: 'Agenda',
	// 	path: '/agenda',
	// 	model_name: 'pending',
	// 	component: '@/views/Pending',
	// 	image_url: 'nuevos-nav-icons/agenda.png',
	// 	can: 'pending.index',
	// 	params: {
	// 		view: 'por-realizar',
	// 	},
	// },
	// {
	// 	path: '/gastos',
	// 	model_name: 'expense',
	// 	component: '@/views/Expense',
	// 	image_url: 'nuevos-nav-icons/gastos.png',
	// 	can: 'expense.index',
	// },
	// {
	// 	text: 'Panel de Control',
	// 	path: '/panel-de-control',
	// 	component: '@/views/PanelDeControl',
	// 	image_url: 'nav-icons/caja.png',
	// 	name: 'panel',
	// 	params: {
	// 		view: 'proveedores',
	// 		sub_view: 'rendimiento-general',
	// 	},
	// },
	// {
	// 	path: '/presupuestos',
	// 	model_name: 'budget',
	// 	component: '@/views/Budget',
	// 	can: 'budget.index',
	// 	if_has_extencion: ['budgets', 'comerciocity_interno'],
	// 	image_url: 'nuevos-nav-icons/presupuesto.png',
	// 	// image_url: 'nav-icons/presupuestos.png',
	// },
	{
		text: 'Tienda Online',
		name: 'online',
		path: '/online',
		component: '@/views/Online',
		params: {
			view: 'pedidos',
		},
		if_has_extencion: 'online',
		can: [
			'order.index',
			'buyer.index',
		],
		/* Badge: pedidos sin confirmar + mensajes de chat sin leer (ver online_menu_alert_count) */
		budget_function: 'online_menu_alert_count',
		image_url: 'nuevos-nav-icons/online.png',
		icon: 'shop',
		// image_url: 'nav-icons/tienda.png',
	},
	{
		text: 'Tienda Nube',
		name: 'tienda_nube',
		path: '/tienda-nube',
		component: '@/views/TiendaNube',
		params: {
			view: 'pedidos',
		},
		if_has_extencion: 'usa_tienda_nube',
		/* Badge que muestra la cantidad de sincronizaciones fallidas con Tienda Nube */
		budget_function: 'tn_failed_syncs_count',
		// can: [
		// 	'order.index',
		// 	'buyer.index',
		// ],
		image_url: 'nuevos-nav-icons/tienda_nube.png',
		icon: 'cloud',
		// image_url: 'nav-icons/tienda.png',
	},
	{
		text: 'MercadoLibre',
		name: 'mercado_libre',
		path: '/mercado-libre',
		component: '@/views/MercadoLibre',
		params: {
			view: 'pedidos',
		},
		if_has_extencion: 'usa_mercado_libre',
		can: [
			'mercado_libre.orders',
		],
		image_url: 'nav-icons/mercado_libre.png',
		icon: 'bag',
	},
	// {
	// 	text: 'Produccion',
	// 	path: '/produccion',
	// 	name: 'produccion',
	// 	component: '@/views/Produccion',
	// 	can: 'produccion.index',
	// 	function: 'toProduccion',
	// 	if_has_extencion: ['production', 'comerciocity_interno'],
	// 	can: [
	// 		'production_movement.index',
	// 		'order_production.index',
	// 		'recipe.index',
	// 	],
	// 	image_url: 'nuevos-nav-icons/produccion.png',
	// },
	{
		text: 'ProduccionV2',
		path: '/produccionV2',
		name: 'produccionV2',
		component: '@/views/ProduccionV2',
		can: 'produccion.index',
		if_has_extencion: ['production', 'comerciocity_interno', 'productionV2'],
		params: {
			view: 'lotes-de-produccion',
		},
		// can: [
		// 	'production_movement.index',
		// 	'order_production.index',
		// 	'recipe.index',
		// ],
		image_url: 'nuevos-nav-icons/produccion.png',
		icon: 'gear-wide-connected',
	},
	{
		text: 'Tesoreria',
		path: '/cajas',
		name: 'caja',
		model_name: 'caja',
		component: '@/views/Caja',
		// if_has_extencion: 'cajas',
		image_url: 'nuevos-nav-icons/cajas.png',
		icon: 'wallet2',
		// image_url: 'nav-icons/cajas.png',
		call_models_always: true,
		can: 'caja.index',
		childrens: [
			{
				path: '/gastos',
				model_name: 'expense',
				component: '@/views/Expense',
				image_url: 'nuevos-nav-icons/gastos.png',
				icon: 'cash-coin',
				can: 'expense.index',
			},
		]
	},
	{
		text: 'ABM',
		name: 'abm',
		params: {
			view: 'listado',
			sub_view: 'categorias',
			model_name: 'category',
		},
		can: 'abm',
		image_url: 'nav-icons-2/abm.png',
		icon: 'sliders',
		// image_url: 'nav-icons/abm.png',
		childrens: [
			{
				model_name: 'employee',
				name: 'employee',
				path: '/empleados',
				component: '@/common-vue/views/Employee',
				check_is_owner: true,
				if_has_extencion: 'comerciocity_interno',
				image_url: 'nuevos-nav-icons/empleados.png',
				icon: 'person-workspace',
				// image_url: 'nav-icons/empleados.png',
			},
			{
				text: 'Papelera',
				path: '/papelera',
				name: 'papelera',
				params: {
					view: 'articulos',
				},
				component: '@/views/Papelera',
				image_url: 'nuevos-nav-icons/papelera.png',
				icon: 'trash',
				// image_url: 'nav-icons/papelera.png',
				check_is_owner: true,
			},
		]
	},
	{
		text: 'Comprobantes',
		path: '/comprobantes',
		name: 'comprobantes',
		component: '@/views/Comprobantes',
		image_url: 'nuevos-nav-icons/comprobantes.png',
		icon: 'file-earmark-text',
		// image_url: 'nav-icons/comprobantes.png',
		params: {
			view: 'notas-de-credito',
		},
	},
	{
		text: 'Cons. Precios',
		path: '/consultora-de-precios',
		name: 'consultora_de_precios',
		component: '@/views/ConsultoraDePrecios',
		if_has_extencion: 'consultora_de_precios',
		image_url: 'nav-icons/consulta_precios.png',
		icon: 'graph-up-arrow',
	},
]